"use client";

import { Message } from "@/lib/core/crm/types";
import { ResponsiveModal, MODAL_IDS } from "@west-tennessee-consulting/ui";
import {
  MessageHeader,
  MessageMetadata,
  MessageContent,
  MessageActions,
  MessageMobileHeaderActions,
  useMessageActionHandlers,
} from "../components";

interface MessageDetailDrawerProps {
  message: Message;
  showActions?: boolean;
  onCopyLink?: () => void;
  isMobile?: boolean;
}

export function MessageDetailDrawer({
  message,
  showActions = true,
  onCopyLink,
  isMobile = false,
}: MessageDetailDrawerProps) {
  const handlers = useMessageActionHandlers(message);

  return (
    <ResponsiveModal
      globalModalId={MODAL_IDS.messages.detail}
      side="bottom"
      title=""
    >
      {/* Header */}
      <div className="flex items-center justify-between w-full min-w-0 gap-4 p-4 border-b">
        {showActions && isMobile && (
          <MessageMobileHeaderActions
            message={message}
            handlers={handlers}
            onCopyLink={onCopyLink}
          />
        )}

        <div className="flex-1 min-w-0">
          <MessageHeader message={message} />
        </div>

        {showActions && !isMobile && (
          <MessageActions message={message} onCopyLink={onCopyLink} />
        )}
      </div>

      {/* Scrollable body */}
      <div className="flex-1 overflow-y-auto">
        <MessageMetadata message={message} />
        <MessageContent message={message} />
      </div>

      {/* Mobile sticky footer actions */}
      {showActions && (
        <div className="sticky bottom-0 border-t bg-background p-4 sm:hidden">
          <MessageActions message={message} onCopyLink={onCopyLink} />
        </div>
      )}

      {/* Confirmation Dialogs */}
      <handlers.ArchiveDialog />
      <handlers.DeleteDialog />
      <handlers.SpamDialog />
    </ResponsiveModal>
  );
}
